import { render, staticRenderFns } from "./CompareBar.vue?vue&type=template&id=a8d4c01c&"
import script from "./CompareBar.vue?vue&type=script&lang=js&"
export * from "./CompareBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports